export default __webpack_public_path__ + "static/media/eotm-may.81cfb1ca.png";